const ee = require('./services');
const moment = window.moment;
const underscore = window.underscore;
const h = require('hyperscript')
angular.module('app', [
    'ngResource',
    'ngSanitize',
    'ui.router',
    'angular-storage',
    'angular-jwt',
    'angucomplete-alt',
    'contentful',
    'ngMap',
    'ui.bootstrap',
    'angularUtils.directives.dirPagination',
    'ngAnimate',
    'stripe.checkout',
    'hc.marked',
    'slugifier',
    '720kb.socialshare',
  ])
  .constant('ee', ee)
  .constant('moment', moment)
  .constant('underscore', underscore)
  .config(['$urlRouterProvider', '$stateProvider', 'contentfulProvider', 'StripeCheckoutProvider', '$locationProvider', '$compileProvider',
    function($urlRouterProvider, $stateProvider, contentfulProvider, StripeCheckoutProvider, $locationProvider, $compileProvider) {
      // Performance improvement/cleaner markup
      // https://medium.com/swlh/improving-angular-performance-with-1-line-of-code-a1fb814a6476
      $compileProvider.debugInfoEnabled(false);
      // Stripe confits
      StripeCheckoutProvider.defaults({
        key: 'pk_live_t4DRLFoNpmoWASIiR1ljn7Qs', // park Live STRIPE KEY
      });
      // Contentful configs
      contentfulProvider.setOptions({
        space: '2e4nhi2s02k7',
        accessToken: 'c85abf8850c5868873e13bb71aea17e65eccabba550f143ea6872a625b730e6f',
      });
      // $urlRouterProvider.otherwise('/');
      $stateProvider
        .state('site', require('./components/layout'))
        .state('site.home', require('./components/templates/home/home'))
        .state('site.contact', require('./components/templates/contact/contact'))
        .state('site.careers', require('./components/templates/careers/careers'))
        .state('site.blog', require('./components/templates/blog/blog'))
        .state('site.blog-post', require('./components/templates/blog-post/blog-post'))
        .state('site.blog-category', require('./components/templates/blog-category/blog-category'))
        .state('site.blog-tag', require('./components/templates/blog-tag/blog-tag'))
        .state('site.team', require('./components/templates/team/team'))
        .state('site.services', require('./components/templates/services/services'))
        .state('site.work', require('./components/templates/work/work'))
        .state('site.workDetail', require('./components/templates/workDetail/workDetail'))
        .state('sitemap.xml', {
          url: '/sitemap.xml'
        })
        .state('robots.txt', {
          url: '/robots.txt'
        })
      $locationProvider.html5Mode({
        enabled: true,
        requireBase: false,
      });
    },
  ])
  .filter('serviceProvided', require('./filters/serviceProvided.js'))
  .filter('service', require('./filters/serviceProvided.js'))
  .filter('telephone', require('./filters/telephone.js'))
  .filter('slugify', require('./filters/slugify.js'))
  .directive('navheader', require('./components/shared/header.js'))
  .directive('homehex', require('./components/homeHex.js'))
  .directive('footermenu', require('./components/shared/footer.js'))
  .factory('emailSvc', ['$http', require('./factories/email')])
  .directive('selectNgFiles', function() {
    return {
      require: 'ngModel',
      link: function postLink(scope, elem, attrs, ngModel) {
        elem.on('change', function(e) {
          var vm = this;
          var xhr = new XMLHttpRequest();
          xhr.responseType = 'blob';
          var files = elem[0].files;
          console.log('files', files);
          ngModel.$setViewValue(files);
          var blob = new Blob([this.response], {
            type: 'application/pdf'
          });
          vm.url = URL.createObjectURL(blob);
            console.log('blob', blob);
          console.log('pdf', vm.url);

          // URL.revokeObjectURL(obj_url);

        })
      }
    }
  })



/** WEBPACK FOOTER **
 ** ./app.js
 **/